<template>
	<div class="productDetails">
		<div class="productDetails-wrap">
			<!-- <div class="top-view-small">
				<div class="product-view">
					<div class="pro-wrap swiper-container">
						<div class="swiper-wrapper ">
							<div class="swiper-slide">slider1</div>
							<div class="swiper-slide">slider2</div>
							<div class="swiper-slide">slider3</div>
						</div>
						<div class="swiper-button-prev"></div>
						
						<div class="swiper-button-next"></div>
					
					</div>
				</div>
			</div> -->
			<div class="bottom-product-content">
				<div class="product-left">
					<div class="product-img">
						<img :src="productDetails.back" v-if="productDetails">
					</div>
				</div>
				<div class="product-descrition">
					<h6>{{productDetails.title}}</h6>
					<div class="content" v-html='productDetails.content'>


					</div>
					<div class="button-wrap">
						<button class="primary-button" @click="buynow">START</button>
						<button class="default-button" @click="gotodingzhi">BACK</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper';
	import {
		Dialog
	} from 'vant';
	import {
		mapState
	} from 'vuex';

	export default {
		name: "productDetails",
		data() {
			return {
				productDetails: {},
				imgList: [],
				shoeDefault: null, //后台设置的默认值 免费楦头
				shape: "标准",
				shapetwo: null,
				shoefistIndex: 0,
				shoelastIndex: 0,
				shapetwoValue: "",
				shoefistArr: [],
				shoelastArr: [{
					name: "标准A版"
				}, {
					name: "窄版N版"
				}, {
					name: "肥版W版"
				}],
				size: 0, //尺码
				num: 1,
				showMask: false,
				goodsId: 0,
				arr: [], //定制生成的图片组合
				sizeArr: [], //定制材质数组
				swiper: null,
				shapetwoPirce: 400, //楦头价格

			}
		},
		watch: {
			shoefistIndex(val) {
				if (val == 0) {
					if (this.size <= 28) {
						this.size = 29;
					}
				}
				if (val == 3) {
					if (this.size <= 28) {
						this.size = 29;
					}
				}


			}
		},
		computed: {
			...mapState({
				web: state => state.web,

			}),
		},
		created() {




		},
		mounted() {

			var app = this;


			app.goodsId = app.$route.params.id;

			this.getProduct();




		},
		methods: {
			gotodingzhi() {

				this.$store.commit("SET_ORDER", {
					type: this.type, //直接购买 2 定制
					id: this.productDetails.id,
					num: this.num,
					shape: this.shape,
					shapetwo: this.shapetwo ? this.shapetwo : this.shoeDefault,
					shapetwoValue: this.shapetwoValue,
					title: this.productDetails.title,
					code: this.size,
					thumb: this.arr.length == 0 ? this.productDetails.thumb : this.arr[0].url,
					price: this.addSize(this.productDetails.price),
					sizeArr: this.sizeArr,
					arr: this.arr.length == 0 ? "" : this.arr,
					title: this.productDetails.title
				})

				this.$router.push('/customized/' + this.goodsId + '?code=' + this.size)
			},
			addSize(price) {
				var p = 0;
				//选择的楦头和系统默认返回的楦头不一致就+400块
				if (this.shapetwo && this.shapetwo != this.shoeDefault) {
					p += 400
				}
				if (this.type == 1) {
					return Number(price) + p

				} else {


					this.sizeArr.forEach(item => {
						if (item && item.price) {

							p += parseFloat(item.price);

							if (item.tprice) {
								p += parseFloat(item.tprice);
							}

						}

					})

					var embroidery = this.$api2.getGhStorageItem("embroidery");


					embroidery.ways.forEach((item, index) => {
						if (item == 1) {
							if (embroidery.logoflag[index]) {
								p += parseFloat(embroidery.technology[index] == "丝印" ? 300 : 250)
							}
						}
						if (item == 2) {
							p += parseFloat(embroidery.technology[index] == "丝印" ? 300 : 250)
						}
						if (item == 3) {
							p += parseFloat(embroidery.customImgColor[index] == "1" ? 400 : embroidery.customImgColor[index] == "2" ? 800 :
								0)
						}
					})


					return Number(price) + p
				}

			},

			getProduct() {

				var app = this;

				this.$api("/index/getGoodsDetail", {
					id: this.goodsId,
				}).then(function(res) {
					if (res.status == "200") {

						app.productDetails = res.data;

						console.log(app.productDetails);
						

					}

				})
			},
			show(index) {

				this.showMask = true;

				if (this.swiper) {
					console.log(this.swiper)
					console.log(index)

					this.swiper.slideTo(index, 1000, false);
					return;
				}

				// this.$nextTick(function() {


				// 		this.swiper = new Swiper('.product-swiper-container', {
				// 			autoplay: true,
				// 			loop: true,
				// 			initialSlide :index,
				// 			slidesPerView: 'auto',
				// 			// 如果需要分页器
				// 			pagination: {
				// 				el: '.swiper-pagination',
				// 			},
				// 		})


				// })
			},
			buynow() {

				this.$router.push('/customized/' + this.goodsId)

			},
			minusQuantity() {
				if (this.num == 1) {
					return;
				}
				this.num--;
			},
			addQuantity() {
				this.num++;
			},
			optsize(item) {
				var app = this;

				this.shoelastIndex = 0;

				if (this.type == 2) {

					if (this.$store.state.web) {


						Dialog.confirm({
							title: '提示',
							message: '当前尺码为定制尺码, 是否重新定制?',
						}).then(() => {
							app.type = 1;
							app.size = item;
							app.arr = [];
							app.$router.push("/product/" + app.goodsId)
						}).catch(() => {
							// on cancel
						});

					} else {
						this.$confirm('当前尺码为定制尺码, 是否重新定制?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							app.type = 1;
							app.arr = [];
							app.size = item;
							app.$router.push("/product/" + app.goodsId)
						}).catch(() => {

						});
					}


					return
				}

				this.size = item;

			}
		}

	}
</script>


<style lang="less">
	.productDetails {
		padding-top: 70px;
		margin-top: 100px;

		.productDetails-wrap {
			max-width: 1520px;
			min-width: 1200px;
			width: 80%;
			box-sizing: border-box;
			min-width: 1200px;
			margin: 0 auto;
			padding: 30px;
			position: relative;

			.top-view-small {
				width: 100%;
				margin-bottom: 50px;

				.pro-wrap {
					padding: 0 100px;
				}
			}

			.bottom-product-content {
				position: relative;
				display: flex;

				.product-left {
					position: relative;
					flex: 0 0 66.66%;
					padding-top: 65%;
					background-color: #f8f8f8;
					box-sizing: border-box;

					.product-img {
						position: absolute;
						top: 50%;
						width: 70%;
						left: 50%;
						transform: translate(-50%, -50%);

						img {

							width: 100%;
						}
					}

					.product-view {
						position: absolute;
						left: 0;
						top: 0;
						width: 150px;
						height: 510px;
						overflow: hidden;

						.swiper-slide {
							height: 150px;
						}
					}
				}

				.product-descrition {
					width: 33.33%;
					height: 100%;
					display: flex;
					flex-direction: column;
					background-color: #fff;
					box-sizing: border-box;
					padding-left: 50px;
					position: absolute;
					right: 0;

					h6 {
						font-size: 30px;
						font-weight: bold;
						line-height: 2;
						padding-bottom: 20px;
						border-bottom: 1px solid #dcdddd;
					}

					.button-wrap {
						padding: 0;
						bottom: 0;
						display: flex;

						&:first-child {
							margin-right: 20px;
						}
					}

					.content {
						flex: 1;
						line-height: 1.6;
						font-size: 14px;
						color: #666666;
						padding: 20px;
						overflow: auto;
					}
				}
			}
		}
	}


	@media screen and (max-width:768px) {

	


		.productDetails {
			padding-top: 0;
			padding-bottom: 70px;

			.productDetails-wrap {
				padding: 0;
				padding-top: 10%;
				width: 100%;
				max-width: 100%;
				min-width: 100%;

				.product-img {
					margin-top: 0px;

					img {
						width: 90%;
					}
				}

				.product-size {
					width: 100%;
					padding: 20px;
					box-sizing: border-box;
					margin-top: 00px;
					margin-left: 0;
					margin-right: 0;
					min-width: 100%;

					h6 {
						font-size: 18px;
						padding-bottom: 10px;
					}

					.des {
						margin: 10px 0;
						line-height: 1.6;
						font-size: 12px;
					}

					.item {
						label {
							font-size: 14px;
						}

						.dl {
							width: 100%;
							margin-bottom: 20px;
							margin-top: 20px;
							font-size: 12px;

							.dd {
								line-height: 36px;
								width: auto;
								padding: 0 12px;
								font-size: 12px;
								text-align: center;
								margin-right: 2%;
								box-sizing: border-box;
								margin-bottom: 2%;
							}

							.price {
								font-size: 12px;
								margin-left: 20px;
							}

							.cul {
								padding: 5px 0;

								button {
									width: 30px;

									i {
										font-size: 10px;
									}
								}

								input {
									width: 36px;
								}
							}
						}
					}

					.num-item {
						display: flex;
						align-items: center;

						.dl {
							width: auto;
							padding-left: 20px;
						}
					}

					.button-wrap {
						width: 100%;
						position: fixed;
						bottom: 0;
						left: 0;
						z-index: 1000;
						box-shadow: 0 0 2px 0px rgba(0, 0, 0, .1);

						button {
							margin: 0;
							flex: 1;
							font-size: 14px;

							&.default-button {
								border-color: #fff;
							}
						}
					}
				}

				.product-view {
					.pro-wrap {
						flex-wrap: wrap;
						margin: 0;

						.img-item {
							margin: 0;
							width: 48%;
							margin: 1%;
						}
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/product/productDetails.vue